import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=9807a4a4&"
import script from "./BlogHome.vue?vue&type=script&lang=js&"
export * from "./BlogHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports